import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react';
import {
  PolymorphicComponentPropWithRef,
  PolymorphicRef,
} from '@diamond/shared/types';
import React from 'react';

/**
 * This is the updated component props using PolymorphicComponentPropWithRef
 */
type ButtonProps<T extends React.ElementType> = PolymorphicComponentPropWithRef<
  T,
  Omit<ChakraButtonProps, 'as'>
>;

/**
 * This is the type used in the type annotation for the component
 */
type ButtonComponent = <T extends React.ElementType = typeof ChakraButton>(
  props: ButtonProps<T>
) => React.ReactElement | null;

export const Button: ButtonComponent = React.forwardRef(
  <T extends React.ElementType = typeof ChakraButton>(
    {
      as,
      type = 'button',
      variant = 'outline',
      disabled,
      children,
      ...rest
    }: ButtonProps<T>,
    ref?: PolymorphicRef<T>
  ) => {
    const Component = as || ChakraButton;
    return (
      <Component
        type={type}
        variant={variant}
        ref={ref}
        fontSize={{ base: '14px', md: '16px' }}
        {...rest}
        disabled={disabled}
      >
        {children}
      </Component>
    );
  }
);
